<template>
  <div class="transfer-pay">
    <el-button v-if="canSelectPayType" type="primary" @click="handleAccountPay">
      生成汇款账号
    </el-button>
    <div v-else class="rules-inbox">
      <div class="account-info">
        <a-descriptions :column="3">
          <a-descriptions-item label="收款户名">
            <span>江西省精彩纵横采购咨询有限公司</span>
          </a-descriptions-item>
          <a-descriptions-item label="汇款账号" :span="2">
            <div v-if="guaranteeInfo.gfAccount">
              <span>
                {{
                  guaranteeInfo.gfAccount
                    ? $bankCardFilter(guaranteeInfo.gfAccount)
                    : '-'
                }}
              </span>

              <span class="text-danger m-l-10">
                该汇款账号具备唯一性，仅适用于当前用户和当前项目，不可用于其他用户和其他项目转账！
              </span>
            </div>
            <span v-else>
              虚拟账号获取失败，
              <a-button
                style="padding: 0"
                type="link"
                @click="getAccountBalance"
              >
                重新获取
              </a-button>
            </span>
          </a-descriptions-item>
          <a-descriptions-item label="开户银行">
            <span>{{ guaranteeInfo.gfAccountBank || '-' }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="开户行号" class="flex-align">
            <span>
              {{
                guaranteeInfo.bankNo
                  ? $bankCardFilter(guaranteeInfo.bankNo)
                  : '-'
              }}
            </span>
            <el-popover
              v-model="showOpenPopover"
              trigger="manual"
              placement="bottom"
              width="240"
            >
              <p>
                开户行号非保证金收款账号，请勿汇款！
              </p>
              <div style="text-align: right; margin: 0">
                <el-button
                  type="primary"
                  size="mini"
                  @click="showOpenPopover = false"
                >
                  确定
                </el-button>
              </div>
              <i
                slot="reference"
                class="tip-button--info el-icon-info"
                @click="showOpenPopover = !showOpenPopover"
              ></i>
            </el-popover>
          </a-descriptions-item>
          <a-descriptions-item label="已缴金额" class="flex-align">
            <div class="flex col-center">
              <span>
                {{
                  guaranteeInfo.gfPayPaid
                    ? strToThousands(`${guaranteeInfo.gfPayPaid}`)
                    : 0
                }}
                元
              </span>
              <a-button
                v-if="payStatus !== depositStatusDict.SUCCESS.value"
                type="link"
                :disabled="!guaranteeInfo.gfAccount"
                class="m-l-4"
                style="padding: 0"
                @click="getGuaranteeInfo"
              >
                刷新到账信息
              </a-button>
              <span
                v-if="
                  payStatus === depositStatusDict.PAYMENT.value &&
                    guaranteeInfo.gfPayPaid
                "
                class="text-danger"
              >
                （请在规定时间内完成缴纳）
              </span>
            </div>
            <money-in-cn :money="guaranteeInfo.gfPayPaid" />
          </a-descriptions-item>
        </a-descriptions>
      </div>
      <deposit-rules />
    </div>
  </div>
</template>

<script>
import MoneyInCn from '@/components/common/MoneyInCn.vue'
import DepositRules from '@/components/copywriter/DepositCopywriter'
import { depositStatusDict } from '@/dictionary/project/common'
import { getGuaranteeFeeAccountApi } from '@/api/supplier/inquiry'
import { strToThousands } from '@/utils/utils'

export default {
  name: 'GuaranteeTransferPay',

  components: { MoneyInCn, DepositRules },

  props: {
    guaranteeInfo: {
      type: Object,
      default: () => {}
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    tradeId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      depositStatusDict,

      showPopover: true,
      showOpenPopover: true
    }
  },

  computed: {
    payStatus() {
      return this.guaranteeInfo.payStatus
    },

    // 是否能选择保证金缴纳方式
    canSelectPayType() {
      return this.payStatus <= depositStatusDict.PENDING.value
    }
  },

  watch: {
    payStatus: {
      handler: function(val) {
        if (val === depositStatusDict.SUCCESS.value) {
          this.showPopover = false
          this.showOpenPopover = false
          this.$emit('refresh')
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,

    /**
     * 使用现金转账，即子账户形式支付
     */
    handleAccountPay() {
      this.$systemConfirm(
        '生成汇款账户后，将不再支持使用会员保证金担保服务，请确认',
        '确认提示'
      ).then(result => {
        if (result) this.getAccountBalance()
      })
    },

    /**
     * 获取保证金账号
     */
    async getAccountBalance() {
      try {
        const { data } = await getGuaranteeFeeAccountApi({
          orderId: this.orderId,
          tradeId: this.tradeId
        })
        if (!data) {
          this.$message.error('网络波动，请重新获取保证金虚拟账号')
          return false
        }
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 刷新保证金信息
     */
    getGuaranteeInfo() {
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped lang="scss">
.rules-inbox {
  border: 1px solid $info-fourth-color;
  border-radius: 4px;
  background-color: $info-sixth-color;
  padding: 20px;
}
</style>
